import React, { Component } from 'react'
import OptimizedImage from '../OptimizedImage'
import boyAndBotHappyImg from '../../images/children/boy_and_bot_happy.png'
import { withTranslation } from 'react-i18next'
import './compact.css'


class ContactHome extends Component {


    state = {
        name: '',
        email: '',
        error: {}
    }


    changeHandler = (e) => {
        const error = this.state.error;
        error[e.target.name] = ''

        this.setState({
            [e.target.name]: e.target.value,
            error
        })
    }

    subimtHandler = (e) => {
        e.preventDefault();

        const { name,
            email,
            error } = this.state;

        if (name === '') {
            error.name = "Please enter your name";
        }
        if (email === '') {
            error.email = "Please enter your email";
        }
        
        if (error) {
            this.setState({
                error
            })
        }
        if (error.name === '' && error.email === '' && error.email === '') {
            this.setState({
                name: '',
                email: '',
                subject: '',
                events: '',
                notes: '',
                error: {}
            })
        }
    }

    render(){
        const { t } = this.props; // Translation function
        const { name,
            email,
            error } = this.state;

        return(

            <section id="contact" className={`wpo-contact-section section-padding ${this.props.cClass || ''}`}>
                <div className="container">
                    <div className="wpo-contact-wrap">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-12">
                                <div className="contact-form">
                                    <div className="contact-form-title">
                                        <h2>{t('contactHome.contactUs')}</h2>
                                        <p>{t('contactHome.reachOut')}</p>
                                    </div>
                                    <form onSubmit={this.subimtHandler} className="form">
                                        <div className="form-field">
                                            <input className="form-control" value={name} onChange={this.changeHandler} type="text" name="name" placeholder={t('contactHome.yourName')}/>
                                            <p>{error.name ? error.name : ''}</p>
                                        </div>
                                        <div className="form-field">
                                            <input className="form-control" onChange={this.changeHandler} value={email} type="email" name="email" placeholder={t('contactHome.yourEmail')}/>
                                            <p>{error.email ? error.email : ''}</p>
                                        </div>
                                        <textarea className="form-control" placeholder={t('contactHome.message')}></textarea>
                                        <button className="theme-btn" type="submit">{t('contactHome.submitNow')}</button>
                                    </form>
                                </div>
                            </div>
                            <div className="col-lg-6 col-12">
                                <div className="contact-img">
                                    <OptimizedImage 
                                        src={boyAndBotHappyImg} 
                                        alt="Boy and Bot Happy" 
                                        loading="lazy" 
                                        decoding="async"
                                        width={600}
                                        height={400}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

}
export default withTranslation()(ContactHome);